import script from "./PlayerProfilePage.vue?vue&type=script&setup=true&lang=js"
export * from "./PlayerProfilePage.vue?vue&type=script&setup=true&lang=js"

import "./PlayerProfilePage.vue?vue&type=style&index=0&id=71729f90&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-71729f90"]])

export default __exports__